import { DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface ItemAmountModel {
  totalAmount?: number | null;
  amountUnit?: string | null;
  contractDuration?: number | null;
}

@Component({
  selector: 'app-item-amount',
  imports: [TranslateModule, DecimalPipe],
  templateUrl: './item-amount.component.html',
  styleUrl: './item-amount.component.scss',
})
export class ItemAmountComponent {
  itemAmountModel = input.required<ItemAmountModel>();
}
